import { Navigate, useSearchParams } from 'react-router-dom';
import { objectiveByKey } from '@/components/google-ads/GoogleAdsObjectives';

export default function GoogleAdsCampaignWizard() {
  const [params] = useSearchParams();
  const objective = objectiveByKey(params.get('objective'));
  return <Navigate replace to={objective?.route ?? '/google-ads/campaigns/objective'} />;
}
